import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { ArrowLeft, ArrowRight, Calendar2Date, Clock, ClockFill } from "react-bootstrap-icons";
import { invoiceTypes, keyIsLetter, keyIsLetterOrNumber, setErrorDialog, translateError } from "../../../store/api/CommonFunctions";
import { getInvoiceAsync, getInvoiceByNumberAsync, getInvoiceNewNumber, getPrvNextInvoiceIDAsync } from "../../store/api/Invoice";
import { useDispatch } from "react-redux";

/**
 * 
 * @param {Object} props 
 * @param {Object} props.invoiceData
 * @param {(Object)=>void} props.setInvoiceData
 * @param {boolean} props.loadingInvoice
 * @param {(boolean)=>void} props.setLoadingInvoice
 * @returns 
 */
const InvoiceTopHead = ({
    invoiceData,
    initData,
    setInvoiceData,
    loadingInvoice,
    setLoadingInvoice,
}) => {
    const dispatch = useDispatch();
    const searchInvoiceTimeoutRef = useRef();

    const [errorFindInvoice, setErrorFindInvoice] = useState(null);
    const getInvByNumber = async (e) => {
        if (e.key === ".") {
            e.preventDefault();
            return;
        }
        if (loadingInvoice) {
            return;
        }
        setErrorFindInvoice(null);
        let number = e.target.value;
        if (keyIsLetter(e.key)) {
            number += e.key;
        }
        else if (e.key === "Backspace" && number.length > 0) {
            number = number.slice(0, number.length - 1);
        }
        if (!number || isNaN(number)) {
            return;
        }
        if (searchInvoiceTimeoutRef.current) {
            clearTimeout(searchInvoiceTimeoutRef.current);
        }
        searchInvoiceTimeoutRef.current = setTimeout(async () => {
            setLoadingInvoice(true);
            const result = await getInvoiceByNumberAsync(number, invoiceTypes.Sale);
            setLoadingInvoice(false);
            if (result.Data) {
                setInvoiceData(result.Data);
            }
            else if (result.Message || result.message) {
                setErrorFindInvoice(translateError(result.Message || result.message));
            }
            else if (result.Data === null) {
                setInvoiceData({ ...initData });
                setErrorFindInvoice("فاکتور درخواستی یافت نشد");
            }
        }, 1500)
    }
    const gotoPrvNextInvoice = async (next) => {
        if (!invoiceData.InvoiceID || loadingInvoice) {
            return;
        }
        setLoadingInvoice(true);
        const result = await
            getPrvNextInvoiceIDAsync(
                invoiceData.InvoiceID,
                invoiceTypes.Sale,
                next);
        if (result?.ID) {
            const invoiceResult = await getInvoiceAsync(result.ID, invoiceTypes.Sale);
            if (invoiceResult?.Message) {
                setErrorDialog(dispatch, invoiceResult.Message, "دریافت اطلاعات فاکتور");
            }
            if (invoiceResult?.InvoiceID) {
                setInvoiceData(invoiceResult);
            }
        }
        setLoadingInvoice(false);
    }
    const handleInvoiceNumber = () => {
        const onGet = (res) => {
            if (!isNaN(res)) {
                setInvoiceData(prev => ({ ...prev, InvoiceNumber: Number(res) }));
            }
        }
        getInvoiceNewNumber(invoiceTypes.Sale, true, onGet);
    }
    useEffect(() => {
        handleInvoiceNumber();
    }, [])

    return (
        <Row className="invoice-top-head rowBorder">
            <Col>
                <Calendar2Date size={15} />&nbsp;
                <label>تاریخ: </label>&nbsp;
                <label>{invoiceData.PContactDate}</label>
            </Col>
            <Col>
                <Clock size={15} />&nbsp;
                <label>ساعت: </label>&nbsp;
                <label>{invoiceData.PContactHour}</label>
            </Col>
            <Col>
                <label >شماره فاکتور:</label>&nbsp;
                <label className="invoice-number">{invoiceData.InvoiceNumber}</label>
            </Col>
            <Col md={4}>
                <div className="find-invoice">
                    <Button variant="outline-primary"
                        disabled={loadingInvoice
                            || !invoiceData?.InvoiceID}
                        onClick={() => gotoPrvNextInvoice(false)}>
                        <ArrowRight />&nbsp; فاکتور قبلی
                    </Button>
                    <Form.Control type="number" placeholder="شماره فاکتور" onKeyDown={getInvByNumber} step={1} />
                    <Button variant="outline-primary"
                        disabled={loadingInvoice
                            || !invoiceData?.InvoiceID}
                        onClick={() => gotoPrvNextInvoice(true)}>
                        فاکتور بعدی &nbsp;
                        <ArrowLeft />
                    </Button>
                </div>
                {errorFindInvoice &&
                    <span className="find-invoice-error">{errorFindInvoice}</span>
                }
            </Col>

        </Row>)
}
export default InvoiceTopHead;